import axios from 'axios';

let sessionRedirectInstalled = false;
let redirectingForExpiredSession = false;

const AUTH_PATHS = [
  '/api/auth/login',
  '/api/auth/register',
  '/api/auth/request-password-reset',
  '/api/auth/reset-password',
];

function requestPath(configUrl = '') {
  try {
    const url = new URL(configUrl, window.location.origin);
    return url.pathname;
  } catch {
    return String(configUrl || '');
  }
}

function hasAuthHeader(config) {
  const headers = config?.headers || {};
  return Boolean(headers.Authorization || headers.authorization);
}

function loginTargetFor(pathname, requestUrl) {
  const path = String(pathname || '');
  const apiPath = requestPath(requestUrl);
  if (apiPath.startsWith('/api/admin') || path.startsWith('/admin')) return '/admin/login';
  return '/login';
}

function clearExpiredSession(loginPath) {
  if (loginPath === '/admin/login') {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return;
  }
  localStorage.removeItem('userToken');
}

export function setupAxiosSessionRedirect() {
  if (sessionRedirectInstalled || typeof window === 'undefined') return;
  sessionRedirectInstalled = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const config = error?.config || {};
      const apiPath = requestPath(config.url);
      const currentPath = window.location.pathname || '/';
      const isAuthEndpoint = AUTH_PATHS.some((path) => apiPath.endsWith(path));
      const isLoginPage = currentPath === '/login' || currentPath === '/admin/login';
      const shouldRedirect = status === 401 && !isAuthEndpoint && !isLoginPage && hasAuthHeader(config);

      if (shouldRedirect && !redirectingForExpiredSession) {
        redirectingForExpiredSession = true;
        const loginPath = loginTargetFor(currentPath, config.url);
        const next = `${currentPath}${window.location.search || ''}${window.location.hash || ''}`;
        clearExpiredSession(loginPath);
        window.location.assign(`${loginPath}?reason=session-expired&next=${encodeURIComponent(next)}`);
      }

      return Promise.reject(error);
    }
  );
}
